import { body18 } from './../../../../../utils/css/typography';
import styled, { css } from 'styled-components/macro';
import backArrow from '../../../../../assets/icons/backArrow.svg';
import { h4, h2, h6 } from '../../../../../utils/css/typography';
import { mobile } from '../../../../../utils/css/media';
import { colorYellow } from '../../../../../utils/css/colors';
import { boldFont } from '../../../../../utils/css/fonts';

export const BackArrow = styled.div`
	background: ${`url(${backArrow}) no-repeat;`};
	width: 13px;
	height: 18px;
`;

export const BackButtonContainer = styled.div`
	display: flex;
	align-items: center;
	cursor: pointer;
`;

export const SpanText = styled.span`
	padding-inline-start: 1rem;
`;

export const PageSubTitle = styled.div<{ isShown?: string }>`
	font-family: ${boldFont};
	padding: 1rem 0;

	visibility: ${({ isShown }) => (isShown === 'host' ? 'hidden' : 'visible')} ${mobile(css`
			${body18};
			margin: 0 24%;
			order: 1;`)};
	
	${mobile(css`
			margin: 0;
	`)}
`;

export const HeaderUpperSide = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;

	${mobile(css`
		flex-direction: column;
		margin-bottom: 3rem;
	`)}
`;

export const Container = styled.div`
	${mobile(css`
		display: flex;
		width: 100%;
		padding: 1rem;
	`)}
`;
export const HostName = styled.div`
	display: flex;
	justify-content: center;
	${h2}
	margin: 1rem 0;

	${mobile(css`
		${h6};
	`)}
`;

export const NumberOfSalonSpan = styled.span`
	${body18};
	background-color: ${colorYellow};
	border-radius: 50%;
	width: 27px;
	height: 28px;
	text-align: center;
	margin: 0 0.3rem;
`;
